import { React, useState, useMemo, useContext, useEffect } from 'react'
import {  useParams  } from 'react-router-dom';
import CapTableDataTable from '../DataTables/CapTableDataTable';
import CfsFinancialsCapTable, { buildMgt7ExportPayload } from '../DataTables/CfsFinancialsCapTable';
import {  getCaptableUrl, exportExcel } from '../../Config/config';
import axios from 'axios';
import Constants from '../../Constants';
import { UserContext } from '../../Contexts/UserContext';
import LockIcon from 'mdi-react/LockIcon';
import ConfirmPopup from '../../Utils/ConfirmPopup';
import useModule from '../../hooks/useModule';
import moment from "moment";
import { DataFoundContext } from "../../Contexts/DataFoundContext";
import ExcelDownloader from '../shared/ExcelDownloader';


const CAP_TABLE_SOURCES = [
  { key: 'standard', label: 'As per latest round' },
  { key: 'mgt7', label: 'As per MGT-7' },
];

const CapTable = ({ peCmpId, companyName, fallbackCapTable, latestStandaloneFy }) => {
  const [captable, setCapTable] = useState();
  const [showXlDownload, setshowXlDownload] = useState(false);
  const { companyId } = useParams();
  const { getToken, isDirectoryUser, isTrialExport, isStudent } = useContext(UserContext);
  let companyFundingId = parseInt(companyId)
  const [alert, setalert] = useState({ message: "", show: false });
  const { primaryMasterId } = useModule();
  const [capTableDate, setCapTableDate] = useState()
  const [capTableNote, setCapTableNote] = useState()
  const { capTableDataFound, setCapTableDataFound } = useContext(DataFoundContext);
  const [primaryCapTableStatus, setPrimaryCapTableStatus] = useState('pending');
  // null until the first source with data arrives; that source becomes the default view.
  const [capTableView, setCapTableView] = useState(null);
  const hasStandardCapTable = primaryCapTableStatus === 'found';
  const hasMgt7CapTable = fallbackCapTable?.length > 0;
  const hasBothCapTables = hasStandardCapTable && hasMgt7CapTable;
  const showMgt7CapTable = hasMgt7CapTable && (!hasStandardCapTable || capTableView === 'mgt7');
  const mgt7ExportPayload = useMemo(() => buildMgt7ExportPayload(fallbackCapTable), [fallbackCapTable]);
  // Latest `fy` (YYYY-MM-DD) across the MGT-7 rows, used only when every row is a PDF or an Excel file with a Mar/Dec `fy`; else null.
  const mgt7Fy = useMemo(() => {
    const isFyUsable = (row) => {
      const filename = row?.filename?.trim() ?? '';
      if (/\.pdf$/i.test(filename)) return true;
      return /\.(xlsx|xlsm|xls)$/i.test(filename) && [3, 12].includes(moment(row?.fy, 'YYYY-MM-DD', true).month() + 1);
    };
    if (!fallbackCapTable?.length || !fallbackCapTable.every(isFyUsable)) return null;
    return fallbackCapTable.reduce((latest, row) => (row?.fy && (!latest || row.fy > latest) ? row.fy : latest), null);
  }, [fallbackCapTable]);
  // const handleFetchCapTableRequestCallback = (response, requestSuccess) => {
  //   try {
  //     setCapTable(response);
  //     console.log("captable1", response);
  //   } catch (e) {
  //     console.log('Error', e)
  //   }
  // };

  // const { data, loading, error } = useQuery(CAP_TABLE, {
  //   variables: { PECompanyId: companyFundingId },
  //   onCompleted: (response) => handleFetchCapTableRequestCallback(response, true),
  //   onError: (response) => handleFetchCapTableRequestCallback(response),
  //   refetch: CAP_TABLE

  // })
  // console.log("captable12", CAP_TABLE)

  // const CapTableData = useMemo(() => captable, [captable]);
  // console.log("captablecaptable", captable);
  // alert(FundingData)

  let blurColumns = false;

  const allowedModulesStr = localStorage.getItem(Constants.localStorageKeys.allowedModules);
  const allowedModulesList = JSON.parse(allowedModulesStr) ?? [];

  if(isDirectoryUser){
    blurColumns = true;
  }
  else if (allowedModulesList.includes("pe") || allowedModulesList.includes("vc")) {
    blurColumns = false;
  } else {
    blurColumns = true;
  }

  console.log((!isDirectoryUser), 'ccd');

 /**
  * The function `getCaptable` makes a POST request to a specified URL with certain data and headers,
  * and then sets the cap table data and related variables based on the response.
  */
  const getCaptable = () => {

    axios(`${getCaptableUrl}`, {
      method: "POST",
      data: {
        company_id: peCmpId ? peCmpId : companyFundingId,
        type: 1
      },
      headers: {
        "Content-Type": "application/json",
        "Authorization": getToken()
      },
    })
      .then((response) => {
        if (response?.data?.success == true && response?.data?.data) {
          setCapTable(response.data?.data);
          setCapTableDate(response.data?.add_on);
		      setCapTableNote(response.data?.notes);
          setPrimaryCapTableStatus('found');
        }else if (response.data.message === 'No Captable data'){
          setPrimaryCapTableStatus('not_found');
        }
      })
      .catch((error) => {
        console.log("API not working", error);
        setPrimaryCapTableStatus('not_found');
      });

  };

  useEffect(() => {
    getCaptable();
    return () => {
      setCapTableDataFound(false);
      setPrimaryCapTableStatus('pending');
      setCapTableView(null);
    }
  }, [companyFundingId])

  /* Show the section as soon as either the standard cap table or the MGT-7 cap table
  (cap_table from /private/cfs/financials/{id}/) has data, defaulting to whichever arrived first. */
  useEffect(() => {
    setCapTableDataFound(hasStandardCapTable || hasMgt7CapTable);
    setCapTableView((view) => view ?? (hasStandardCapTable ? 'standard' : hasMgt7CapTable ? 'mgt7' : null));
  }, [hasStandardCapTable, hasMgt7CapTable])



  // const indexOfLastPost = currentPage * dataPerPage;
  // // alert(indexOfLastPost)
  // const indexOfFirstPost = indexOfLastPost - dataPerPage;
  // // alert(indexOfFirstPost)
  // const currentData = CapTableData?.company?.investments?.slice(indexOfFirstPost, indexOfLastPost);
  // // alert(currentData );
  // const pageNumbers = []

  // for (let i = 1; i <= Math.ceil(CapTableData?.company?.investments?.length / dataPerPage); i++) {
  //   pageNumbers.push(i);
  // }
  // const setPage = (pageNum) => {
  //   setCurrentPage(pageNum)

  // }
  // const [currentPage, setCurrentPage] = useState(1);
  // const [dataPerPage, setDataPerPage] = useState(20);


  // const indexOfLastPost = currentPage * dataPerPage;
  // const indexOfFirstPost = indexOfLastPost - dataPerPage;
  // const currentData = NewsLetterData?.newsletter?.slice(indexOfFirstPost, indexOfLastPost);
  // // alert(currentData)
  // const pageNumbers = []

  // for (let i = 1; i <= Math.ceil(NewsLetterData?.newsletter?.length / dataPerPage); i++) {
  //   pageNumbers.push(i);
  // } 
  // const setPage = (pageNum) => {
  //   setCurrentPage(pageNum)

  // }
  // const customStringSortMemo = useMemo(() => {
  //   return (rowA, rowB, columnId, desc) => {
  //     const defaultVal = desc ? '--' : 'A';
  //     return (rowA?.values[columnId]?.name ?? defaultVal).localeCompare(rowB?.values[columnId]?.name ?? defaultVal);
  //   }
  // }, []);

 /* The above code is defining a function that generates an array of columns for a table. It uses the
 `useMemo` hook to memoize the columns array and only regenerate it when the `captable` variable
 changes. */
  const columns = useMemo(() => {
    let columns = [];

    // columns.push({
    //     id: 'expander',
    //     Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
    //       <span {...getToggleAllRowsExpandedProps()}>
    //         {isAllRowsExpanded ? ' - ' : ' + '}
    //       </span>
    //     ),
    //     enableSorting: false,
    //     Cell: ({ row }) =>
    //         <span
    //           {...row.getToggleRowExpandedProps({
    //             style: {
    //               paddingLeft: `${row.depth * 2}rem`,
    //             },
    //           })}
    //         >
    //           {row.isExpanded ? ' - ' : ' + '}
    //         </span>
    //   },)
    
    // columns.push({
    //   id: 'shareHolder',
    //   Header: captable?.headers?.at(0) ?? "Shareholders",
    //   accessor: captable?.headers?.at(0) ?? "Shareholders",
    //   headerClasName: "w-[15%]",
    //   Cell: ({ value }) => {
    //     return value.name ? <span className="flex">
    //       {value.name}
    //       <span className="mx-2 inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-xs font-medium text-red-800">
    //         {value?.flag}
    //       </span>
    //     </span> : <span className="flex font-bold">{value}</span>
    //   },
    // })

    captable?.headers?.forEach((header, index) => {
      // investment?.CaptableModuleDetail?.map(ctm => {
      //   ctm?.captableModuleRoundDetail?.map(ctmd => {
      //     const isColumnExist = Array.from(columns).findIndex((col, i) => col.accessor == ctmd?.roundMap?.new_round) != -1;
      //     if (isColumnExist == false) {
      //       columns.push({
      //         Header: ctmd?.roundMap?.new_round,
      //         accessor: ctmd?.roundMap?.new_round,
      //         className:"pr-[2.5rem] w-[7%] text-right"
      //       })
      //     }
      //   })
      // })
      if (index != 0 && (captable?.headers?.length - 1) != index && (captable?.headers?.length - 2) != index && (captable?.headers?.length - 3) != index) {
        columns.push({
          Header: header,
          accessor: header,
          className: "pr-[2.5rem] w-[7%] text-right"
        })
      }
    });
    columns.push({
      Header: captable?.headers?.at(captable?.headers?.length - 3) ?? "Total No. of Shares Held",
      accessor: (data) => {
        return data[captable?.headers?.at(captable?.headers?.length - 3) ?? "Total No. of Shares Held"]
      },
      className: 'text-right pr-[2.5rem] w-[10%]'
    });
    columns.push({
      Header: captable?.headers?.at(captable?.headers?.length - 2) ?? "Stake Held",
      accessor: (data) => {
        return data[captable?.headers?.at(captable?.headers?.length - 2) ?? "Stake Held"]
      },
      className: 'text-right pr-[2.5rem] w-[10%]'
    });
    columns.push({
      Header: captable?.headers?.at(captable?.headers?.length - 1) ?? "Valuation as per the last transaction",
      accessor: captable?.headers?.at(captable?.headers?.length - 1) ?? "Valuation as per the last transaction",
      className: 'text-right pr-[2.5rem] w-[10%]'
    });
    // captable?.headers?.forEach(header => {
    //   columns.push({
    //     Header: header,
    //     accessor: header,
    //     className: `${header == "Total No. of Shares Held" || header == "Valuation as per the last transaction" ? "text-right" : ""} pr-[2.5rem] w-[12%]`,
    //     headerClasName: "w-[10%]",
    //   });
    // });

    return columns;
  },
    [captable]);


 /* The above code is a JavaScript function that uses the `useMemo` hook to memoize the result of the
 function. It takes an input `captable` and returns an array of `rows` based on the data in
 `captable`. */
  const rowData = useMemo(() => {
    let rows = [];
    // rows = captable?.captable ?? [];

    captable?.captable?.map(row => {
      row?.subRows?.map(subRow => {
        rows.push(subRow);
      })
    })
    // captable?.length > 0 &&( 
    // captable?.company?.investments?.forEach((investment) => {
    //   investment.CaptableModuleDetail?.forEach(cmd => {
    //     let row = {};
    //     row.shareHolder = {name:`${cmd.first_name} ${cmd?.last_name ?? ""}`,id:''};
    //     row.totalShares = cmd?.total_shares;
    //     row.valueationPerLastTransaction = cmd?.valuation_last_round;
    //     cmd.captableModuleRoundDetail?.forEach(cmdR => {
    //       row[`${cmdR.roundMap.new_round}`] = cmdR.value;
    //     })
    //     rowsData.push(row);
    //     console.log(rowsData,"rowsData12")
    //   })
    // }))

    // captable?.captable?.forEach(cTable=>{
    //   let row = {};
    //   Object.keys(cTable).forEach(key=>{
    //     row[key] = cTab
    //   })
    // })

    setshowXlDownload(rows.length != 0)

    return rows;
  }, [captable])

  // const initialSort = useMemo(() => [
  //   {
  //     id: "shareHolder",
  //     desc: false
  //   }
  // ], []);

 /**
  * The function `onConfirmation` sets the `show` property of an `alert` object to `false` and clears
  * the `message` property.
  * @param flag - The `flag` parameter is a boolean value that indicates whether a confirmation action
  * has been confirmed or not.
  */
  const onConfirmation = (flag) => {
    setalert({ show: false, message: "" })
  }

  /**
   * The function `onLockClick` displays a warning message to the user.
   * @param cell - The "cell" parameter is a variable that represents a specific cell or element that
   * is being clicked or interacted with.
   */
  const onLockClick = (cell) => {
    // console.log("cellcell", cell);
    // toast.warning("Please buy PE")
    setalert({ show: true, message: Constants.subscribeProductMsg, isAlertOnly: true, closeBtnName: "OK" })
  }

  return (
    <>{capTableDataFound ? 
    <div className="mx-4">
      <div className="bg-white border overflow-hidden sm:rounded-lg shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">
        <div className="pt-4 px-5">
          <div className="flex justify-between mb-3">
            <h3 className="text-[14pt] leading-[19pt] text-[#333333] lg:text-[17px] font-semibold  lg:leading-[22px] ">
              Cap Table{!showMgt7CapTable && capTableDate && <span> (as on {moment(capTableDate , 'YYYY-MM-DD').format('MMM YYYY')})</span>}
              {showMgt7CapTable && (mgt7Fy || latestStandaloneFy) && <span> {mgt7Fy ? `(FY${moment(mgt7Fy, 'YYYY-MM-DD').format('YY')})` : `(FY${latestStandaloneFy})`}</span>}
            </h3>

            <div className="flex items-center gap-3">
            {hasBothCapTables && !blurColumns &&
              <div role="tablist" aria-label="Cap table source" className="inline-flex items-center rounded-full bg-[#F3F3F3] p-1 border border-[#E5E5E5]">
                {CAP_TABLE_SOURCES.map(({ key, label }) => {
                  const active = capTableView === key;
                  return (
                    <button
                      key={key}
                      type="button"
                      role="tab"
                      aria-selected={active}
                      onClick={() => setCapTableView(key)}
                      className={`px-4 py-1.5 rounded-full text-[13px] leading-[16px] whitespace-nowrap transition-all duration-200 focus:outline-none ${
                        active
                          ? 'bg-white text-[#BC8B20] font-semibold shadow-[0_1px_4px_rgba(0,0,0,0.15)]'
                          : 'text-[#666666] font-medium hover:text-[#333333]'
                      }`}
                    >
                      {label}
                    </button>
                  );
                })}
              </div>
            }
            {!hasBothCapTables && !blurColumns &&
              <div className="inline-flex items-center rounded-full bg-[#F3F3F3] p-1 border border-[#E5E5E5]">
                <span className="px-4 py-1.5 rounded-full text-[13px] leading-[16px] whitespace-nowrap bg-white text-[#BC8B20] font-semibold shadow-[0_1px_4px_rgba(0,0,0,0.15)]">
                  {CAP_TABLE_SOURCES[showMgt7CapTable ? 1 : 0].label}
                </span>
              </div>
            }

            {isTrialExport != "false" && isStudent == "false" && showXlDownload && !showMgt7CapTable && <ExcelDownloader
              url={exportExcel}
              fileName={Constants.exportNames.captable(companyName)}
              data={{
                "type": 1,
                "export_from": "detail",
                "module_type": "investments",
                "section": "cap_table",
                "company_id": [peCmpId ? peCmpId : companyFundingId]
              }} />}
            {isTrialExport != "false" && isStudent == "false" && showMgt7CapTable && !blurColumns && mgt7ExportPayload.rows.length > 0 && <ExcelDownloader
              url={exportExcel}
              fileName={`${Constants.exportNames.captable(companyName)} (MGT-7)`}
              data={{
                "type": 1,
                "export_from": "detail",
                "module_type": "investments",
                "section": "cap_table_mgt7",
                "company_id": [peCmpId ? peCmpId : companyFundingId],
                "company_name": companyName ?? "",
                ...mgt7ExportPayload
              }} />}
            </div>
          </div>
        </div>
        {
          blurColumns
            ? <div className='w-full h-40 relative'>
              <div className='absolute w-full h-full blur-sm bg-[#DCDCDC]'></div>
              <div className='absolute w-full h-full flex items-center justify-center'>
                <LockIcon className='cursor-pointer' size={26} onClick={onLockClick} color='#696969'/>
              </div>
            </div>
            : showMgt7CapTable
              ? <CfsFinancialsCapTable data={fallbackCapTable} />
              : <CapTableDataTable
              columns={columns}
              data={rowData}
              // sortBy={initialSort}
              />
            }
        {!showMgt7CapTable && capTableNote !== "null" &&
            <div class="px-5 py-4 text-left pl-[2rem] text-xs font-medium"><span>Note: {capTableNote}</span></div>
        }

        {/* {currentData?.length > 20 ?
          <div className="w-full flex items-center py-3 justify-center space-x-6  ">
          {pageNumbers.map((pageNum, index) => (
            <span key={index} className={pageNum == currentPage ?
              "cursor-pointer flex items-center justify-center py-1  px-3 border-1  rounded-full bg-[#BC8B20] text-white"
              : "cursor-pointer flex items-center justify-center  rounded-full"}
              onClick={() => { setPage(pageNum) }}>
                {pageNum}
              </span>
            ))
            }
          </div>
          : ''
          
        } */}
      </div>
      {<ConfirmPopup {...alert} onChange={onConfirmation} />}
    </div>
        :''}</>
  );
};

export default CapTable;
